import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import styles, { createCircleStyle, getRandomCoordinate } from './styles';

const themes = {
  default: {
    background: 'kit.background.turquoiseSecond',
    circles: ['#00BFFB', '#00BFFB', '#B7F9FF'],
  },
  paleBlue: {
    background: 'kit.background.white',
    circles: ['#75A4FF'],
  },
  paleViolet: {
    background: 'kit.background.white',
    circles: ['#B79DFF', 'rgbA(174, 146, 253, 0.4);', 'rgbA(66, 0, 255, 0.3)'],
  },
  standard: {
    background: 'kit.background.turquoise',
    circles: [],
    circlesCount: 0,
  },
};

const createCircles = (circlesCount, colors) => {
  const circles = [];

  for (let i = 1; i <= circlesCount; i++) {
    const currentBgIndex = Math.round(
      0 + Math.random() * (colors.length + 1 - 0),
    );

    circles.push({
      blur: '8px',
      background: colors[currentBgIndex] || 'inherit',
      x: getRandomCoordinate(-40, 100),
      y: getRandomCoordinate(-40, 100),
      animation: `circle-${i}`,
      duration: '8s',
      easing: 'linear',
      willChange: 'transform',
    });
  }

  return circles;
};

function AnimatedLabel({ children, circlesCount = 15, theme = 'default' }) {
  const [circles, setCircles] = useState([]);
  const [currentTheme] = useState(themes[theme]);

  useEffect(() => {
    setCircles(() =>
      createCircles(
        currentTheme.circlesCount ?? circlesCount,
        currentTheme.circles,
      ),
    );
  }, []);

  return (
    <Box sx={styles.main}>
      <Box
        sx={{
          ...styles.animationBlock,
          backgroundColor: currentTheme.background,
        }}
      >
        {circles.map((circle, index) => (
          <Box key={index} component="span" sx={createCircleStyle(circle)} />
        ))}
      </Box>
      <Box sx={styles.content}>{children}</Box>
    </Box>
  );
}

export default AnimatedLabel;
